import { Grid } from "@mui/material";
import { styled } from "@mui/material";

import Modal from "../../../../../../../../components/Generic/Modal";

export const ModalCustom = styled(Modal)(() => ({
  // width: "100%",
}));

export const PortQuantityBadgeContainer = styled(Grid)(() => ({
  position: "relative",
  top: "24px",
  left: "8px",
}));

export const ModalSection = styled("section")(() => ({
  paddingTop: "1rem",
  width: "100%",
}));
